import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { PlaceholderModalComponent } from '@ispm/layout/components/modals/placeholder-modal/placeholder-modal.component';
import { PlaceholderModalLoaderPayload } from '@ispm/layout/classes/placeholder-modal-loader-payload';
import { ModalTypes } from '@ispm/layout/components/modals/contants/modal-types.enum';
import { DynamicModalLoaderService } from '@ispm/layout/services/dynamic-modal-loader.service';
import { AddRichNotesComponent } from '../add-rich-notes.component/add-rich-notes.component';
import { modalResponse } from '@ispm/layout/constants/modal-responses.enum';

@Component({
  selector: 'gen-rich-notes',
  templateUrl: './rich-notes.component.html',
  styleUrls: ['./rich-notes.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RichNotesComponent implements OnInit {
  static NOTES_WITH_DATA_CLASS = 'notes-with-data';
  static NOTES_WITHOUT_DATA_CLASS = 'notes';

  @Input()
  title = 'Notes';
  @Input()
  notes = { text: ''};
  @Output() notesChanged: EventEmitter<any> = new EventEmitter();

  constructor(private modalLoader: DynamicModalLoaderService, private changeDetRef: ChangeDetectorRef) {
  }
  ngOnInit() {
    this.notes = (this.notes || { text: ''});
  }


  openNotesDialog() {
    this.modalLoader.popupModal(PlaceholderModalComponent,
      new PlaceholderModalLoaderPayload(
        this.title,
        AddRichNotesComponent,
        'Save', // 'Save changes',
        'Cancel', // 'Cancel',
        {
          notes: this.notes.text,
        },
      ), ModalTypes.NONE, 'DYNAMIC_MODAL_LOADER2')
      .filter(response => response.payload.status === modalResponse.approve)
      .subscribe(res => {
        this.changeDetRef.markForCheck();
        this.changeDetRef.detectChanges();
        this.notesChanged.emit({ text: res.payload.payload.value});
      });
  }

  getNotesClass() {
    if (this.notes && this.notes.text && this.notes.text.length > 0) {
      return RichNotesComponent.NOTES_WITH_DATA_CLASS;
    } else {
      return RichNotesComponent.NOTES_WITHOUT_DATA_CLASS;
    }
  }

}
